import Marquee from "react-fast-marquee";
import regiteraddressChangeImg from "../../assets/images/registerd-address-change.png";
import { fpRealaatedArticales } from "../../data/relatedArticale";
import Faq from "../Faq";
import Meta from "../Meta";


export default function RegisteredAddressChange() {
 const faqItems = [
  {
    title: 'Can a company change its registered office address in Bangladesh?',
    content: <strong>Yes, a company can change its registered office address by passing a board resolution and submitting the necessary forms and documents to the Registrar of Joint Stock Companies and Firms (RJSC).</strong>,
  },
  {
    title: 'What forms are required to change the registered office address?',
    content: <strong>Form I (Notice of Situation of Registered Office) and the special resolution (if applicable) must be filed with RJSC along with proof of the new address.</strong>,
  },
  {
    title: 'How long does it take to process the address change?',
    content: <strong>Typically, it takes 7–10 business days after submitting the correct documentation to RJSC for the change to be updated officially.</strong>,
  },
];

return (
  <>
    <Meta
      title="Registered Address Change in Bangladesh | Company Address"
      description="Change of registered office address service in Bangladesh, including RJSC documentation, legal compliance, and consulting support."
      image={regiteraddressChangeImg}
      keywords="registered address change, office address update, RJSC, Bangladesh company compliance"
    />

    <div className="container-fluid hero-header bg-light py-5 mb-5">
      <div className="container py-5">
        <div className="row g-5 align-items-center">
          <div className="col-lg-6">
            <h1 className="display-4 mb-3 animated slideInDown">Registered Office Address Change</h1>
             <p>To change a company's registered address, you generally need to file a formal notice with the Registrar of Joint Stock Companies and Firms (RJSC) to keep public records up to date and remain compliant.</p>
          </div>
          <div className="col-lg-6 animated fadeIn">
            <img className="img-fluid animated pulse infinite" style={{ animationDuration: '3s' }} src={regiteraddressChangeImg} alt='registered-address-change' />
          </div>
        </div>
      </div>
    </div>

    <div className="container-xxl py-5">
      <div className="container">
        <p className="color-text fs-5 mb-4">
          <b>What is a registered office address change?</b>
        </p>
        <p>
          A registered office address is the official location of a company used for government and legal correspondence. When a business relocates its office or wants to change this address, it must notify the Registrar of Joint Stock Companies and Firms (RJSC) to keep public records up to date and remain compliant.
        </p>
        <p className="color-text fs-5 mb-4">
          <b>Why is it important to update the registered office address?</b>
        </p>
        <p>
          Keeping your registered address updated ensures that all official documents, government notices, and legal correspondence reach your company without delay. Failure to update this can result in penalties or non-compliance issues.
        </p>
      </div>
    </div>

    <div className="container-xxl py-5">
      <div className="container">
        <div className="row g-5 align-items-center">
          <div className="col-lg-6">
            <img className="img-fluid" src={regiteraddressChangeImg} alt='registered-address-change-process' />
          </div>
          <div className="col-lg-6">
            <div className="h-100">
              <p className="color-text fs-5 mb-4">
                What services does ‘JK Associates’ offer for Registered Office Address Change?
              </p>
              <ul>
                <li><b>Consultation: </b>Initial evaluation of the required changes and legal obligations.</li>
                <li><b>Document Preparation: </b>Drafting board resolutions, completing Form I, and preparing supporting documents.</li>
                <li><b>Submission to RJSC: </b>Timely filing of forms and follow-up on approval status.</li>
                <li><b>Legal Advisory: </b>Ensuring compliance with Companies Act and relevant regulations.</li>
                <li><b>Communication Handling: </b>Liaison with RJSC and other legal bodies on behalf of the client.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="container-xxl py-0">
      <div className="container">
        <p className="color-text fs-5 mb-4">
          <b>Process of Changing a Registered Address</b>
        </p>
        <ul>
          <li><b>Board Resolution: </b>Pass a resolution to approve the address change.</li>
          <li><b>Documentation: </b>Prepare Form I and supporting documents.</li>
          <li><b>Submission: </b>File the forms to RJSC with prescribed fees.</li>
          <li><b>Approval: </b>Receive acknowledgment and updated incorporation documents.</li>
          <li><b>Notification: </b>Inform stakeholders and update address on company materials.</li>
        </ul>

        <p className="color-text fs-5 mb-4">
          <b>Requirements for Address Change</b>
        </p>
        <ul>
          <li>Certified copy of board resolution</li>
          <li>Form I with full details of new address</li>
          <li>Tenancy agreement or utility bill (as address proof)</li>
          <li>Updated Memorandum & Articles of Association (if applicable)</li>
        </ul>

        <p className="color-text fs-5 mb-4">
          <b>Selection Criteria for New Address</b>
        </p>
        <ul>
          <li><b>Accessibility: </b>Central or business district preferred</li>
          <li><b>Legitimacy: </b>Official documents must support the change</li>
          <li><b>Compliance: </b>Meets RJSC & zoning regulations</li>
          <li><b>Stability: </b>Should reflect long-term business presence</li>
        </ul>
      </div>
    </div>

    <div className='container-xxl center-background1'>
      <h2>Related Articles</h2>
    </div>
    <div className='container-xxl center-background1'>
      <Marquee className="marquee-container">
        {fpRealaatedArticales}
      </Marquee>
    </div>

    <div className="container py-5 my-0">
      <h2 className="color-text text-center mb-4">Registered Address Change FAQ</h2>
      <Faq items={faqItems} />
    </div>
  </>
);

}
